import axios, { AxiosResponse, CancelToken, ResponseType } from 'axios';
import { redirect } from 'react-router-dom';
import { logout } from './ApiActions/authAct';

export type ApiRequestType = 'get' | 'post' | 'put' | 'delete';

interface APIType {
  api: string;
  method: ApiRequestType;
  baseurl?: string;
  body?: any;
  auth?: boolean;
  isPublic?: boolean;
  cancelToken?: CancelToken; // Add cancelToken property
  responseType?: ResponseType; // Add cancelToken property
}

const axiosInstance = axios.create({});
axiosInstance.interceptors.request.use((config) => {
  config.headers['x-api-key'] = process.env.REACT_APP_API_KEY;
  return config;
});

const api = async ({
  api,
  method = 'get',
  baseurl = 'baseurl',
  isPublic = false,
  auth = true,
  body,
  cancelToken, // Accept cancel token as a parameter
  responseType,
}: APIType) => {
  return await new Promise((resolve, reject) => {
    //get content using stapi's in-build api
    //axiosInstance.defaults.headers.Authorization = `Bearer REACT_APP_CMS_TOKEN`;
    //axiosInstance.defaults.headers['Content-Type'] = 'application/json';
    //axiosInstance.defaults.headers['Accept'] = 'application/pdf';
    if (responseType) {
      axiosInstance.defaults.responseType = responseType;
    }

    // Always send cookies with requests
    axiosInstance.defaults.withCredentials = true;

    // We no longer manually attach the Bearer token as it's handled via HttpOnly cookie
    (
      axiosInstance[method] as (
        url: string,
        data?: any,
        config?: any
      ) => Promise<AxiosResponse>
    )(`${getApiBaseUrl(baseurl)}${api}`, body, {
      cancelToken,
    })
      .then((res: any) => {
        resolve(res.data);
      })
      .catch(async (error: any) => {
        if (error.code == 'ERR_CANCELED') {
          return;
        }
        if (error.response?.status && error.response?.status === 401) {
          await logout();
          redirect('/login');
        } else if (error.response) {
          reject(error.response.data);
        } else {
          reject(error);
        }
      });
  });
};

const getApiBaseUrl = (type: string) => {
  switch (type) {
    case 'cmsbaseurl':
      return `${process.env.REACT_APP_CMS_BASE_URL}`;
    case 'baseurl':
      return `${process.env.REACT_APP_CMS_BASE_URL}`;
    case 'notificationurl':
      return `${process.env.REACT_APP_CMS_BASE_URL_NOTIFICATION}`;
    default:
      return process.env.REACT_APP_API_BASE_URL;
  }
};

export default api;
